
import { useNavigate, useParams } from "react-router-dom";
import { Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { separadorMillares, useValidarRoles } from "../../../hooks";
import { LayoutTabla } from "../../layouts";
import { useOPXID } from "../../../hooks/cache";
import { useCarritoItemsStore, useModalStore } from "../../../stores";
import { useQueryClient } from "@tanstack/react-query";
import { VALOR_PRECIO } from "../../../data";
import { startDeleteItemDeOP } from "../../../services";

import Swal from "sweetalert2";



export const ItemsProduccionAndEditar = ({ data }) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { permitirXRol } = useValidarRoles();
    const queryClient = useQueryClient();
    const { data:op } = useOPXID(id);
    const { modalFormToggle } = useModalStore();
    const { setActivarItem } = useCarritoItemsStore();
    

    const editarItemOP = (item) => {
        setActivarItem(item)
        modalFormToggle(true);
    }

    
    const detallesItems = (uid) => {
        navigate(`/super/dt-pro-op/${uid}`);
    }
    


    const eliminarItem = async(uid) => {
        const resp = await Swal.fire({
            title: 'Eliminar item de la OP',
            text: `¿Esta seguro de eliminar este item de la op...?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si'
        });
        if( resp.value ) {
            const resp = await startDeleteItemDeOP(uid)
            if( resp ){
                queryClient.invalidateQueries({ queryKey: ['carritoxop'] });
                queryClient.invalidateQueries({ queryKey: ['op-id'] });
            }
            
        }
    }



    return (
        <>
        {(data?.length > 0)
        ?   <LayoutTabla>
                <TableHead >
                    <TableRow>
                        <TableCell sx={{width:'10%'}}>CANTIDAD</TableCell>
                        <TableCell sx={{width:'35%'}}>PRODUCTO</TableCell>
                        <TableCell sx={{width:'17%'}}>AREA</TableCell>
                        <TableCell sx={{width:'20%'}}>VALOR</TableCell>
                        <TableCell sx={{width:'15%'}}>OPCIONES</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( item => (
                    <TableRow key={ item.id } >
                        <TableCell>{ item.cantidad }</TableCell>
                        <TableCell>{ item.producto.nombre }</TableCell>
                        <TableCell>{ item.area }</TableCell>
                        <TableCell>{`$${separadorMillares(item[VALOR_PRECIO[item.op.view]] || 0)}`}</TableCell>
                        <TableCell>
                        <Stack direction="row" spacing={1} justifyContent="center">
                            <TooltipAndIcon
                                titulo="Detalles del Item"
                                icono="ver"
                                color="white"
                                onClick={ () => detallesItems(item.id) }
                            /> 
                            {(permitirXRol('SUPERADMIN', 'ADMINISTRADOR') ) &&
                            <>
                            <TooltipAndIcon
                                titulo="Editar"
                                icono="editar"
                                color="white"
                                onClick={ () => editarItemOP(item) }
                            />  
                                
                            <TooltipAndIcon
                                titulo="Eliminar Item"
                                icono="eliminar"
                                color="red"
                                onClick={ () => eliminarItem(item.id) }
                            />
                            </>
                            }
                            
                        </Stack>
                        </TableCell> 
                    </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={3}>Total:</TableCell>
                        <TableCell colSpan={2}>{`$${separadorMillares(op?.totalOrden || 0)}`}</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>

        :   <MensajeAlertaDanger titulo='No hay Items de producción' />
        }
        </>

    )
}
